import { useRef, useEffect } from 'react';

function useOnUpdate(fn, inputs) {
  const didMountRef = useRef(false);

  useEffect(() => {
    if (didMountRef.current) {
      return fn();
    }
    didMountRef.current = true;
  }, inputs);
}

export default useOnUpdate;
